<template>
	<div class="tab-item-wrapper card">
		<v-layout fill-height>
			<v-row style="width:100%">
                <!-- مدين -->
				<v-col cols="12" lg="6" sm="12" class="pl-lg-0 pl-md-0">
					<v-card flat>
						<v-card-title class="py-1" style="background-color: #F1F1F1" dark>
							<v-spacer></v-spacer>
                            {{$t('debit')}}
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text class="px-0">
                            <!-- table -->
							<bee-simple-table
								context="final_account"
								:action-name="actions.GET"
								:with-color="false"
								:zebra="false"
								:hide-footer="true"
								empty-state="none"
								fixed-header
								:height="$vuetify.breakpoint.height - 370"
								:headers="debit_headers"
								:configs="configs || []"
								:items="final_accounts_debit_rows"
							></bee-simple-table>

                            <!-- extra rows -->
							<bee-table-row
								v-if="calculatedWarehousesInventoryRow.debit_balance && calculatedWarehousesInventoryRow.debit_balance.amount"
								class="y-border"
								style="width:100%;"
								:item="calculatedWarehousesInventoryRow"
								:headers="debit_headers_extension"
								:editable="false"
							>
								<template
									v-for="header in debit_headers_extension"
									v-slot:[`item.${debit_headers_extension.indexOf(header)}`]="{ item }"
								>
									<bee-money-field
										context="final_account"
										:action-name="actions.GET"
										class="input-text-center"
										v-if="header.type == 'money'"
										:inside-table="true"
										:readonly="true"
										:key="header.id"
										v-model="item[`${header.value}`]"
									></bee-money-field>
									<span v-else :key="header.id">{{item[`${header.value}`]}}</span>
								</template>
							</bee-table-row>

							<bee-table-row
								v-if="calculatedRow.debit_balance || false"
								class="y-border"
								style="width:100%;"
								:item="calculatedRow"
								:headers="debit_headers_extension"
								:editable="false"
							>
								<template
									v-for="header in debit_headers_extension"
									v-slot:[`item.${debit_headers_extension.indexOf(header)}`]="{ item }"
								>
									<bee-money-field
										context="final_account"
										:action-name="actions.GET"
										class="input-text-center"
										v-if="header.type == 'money'"
										:inside-table="true"
										:readonly="true"
										:key="header.id"
										v-model="item[`${header.value}`]"
									></bee-money-field>
									<span v-else :key="header.id">{{item[`${header.value}`]}}</span>
								</template>
							</bee-table-row>

							<div class="d-inline" v-if="sum_result.sum_debits">
								<bee-table-row
									v-if="sum_result.sum_debits.amount"
									class="y-border"
									style="width:100%;"
									:item="sum_result"
									:headers="sum_debits_headers"
									:editable="false"
								>
									<template
										v-for="header in sum_debits_headers"
										v-slot:[`item.${sum_debits_headers.indexOf(header)}`]="{ item }"
									>
										<bee-advanced-money-label
											:currencies="configs.currencies"
											:bold="false"
											style="font-size:16px !important"
											class="input-text-center"
											v-if="header.type == 'money'"
											:with-color="true"
											:key="header.id"
											v-model="item[`${header.value}`]"
										></bee-advanced-money-label>
									</template>
								</bee-table-row>
							</div>
						</v-card-text>
					</v-card>
				</v-col>

                <!-- دائن -->
				<v-col cols="12" lg="6" sm="12">
					<v-card flat>
						<v-card-title class="py-1" style="background-color: #F1F1F1">
							<v-spacer></v-spacer>
                            {{$t('credit')}}
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text class="px-0">
                            <!-- table -->
							<bee-simple-table
								context="final_account"
								:action-name="actions.GET"
								:with-color="false"
								:zebra="false"
								:hide-footer="true"
								empty-state="none"
								fixed-header
								:height="$vuetify.breakpoint.height - 370"
								:headers="credit_headers"
								:items="final_accounts_credit_rows"
								:configs="configs || []"
							></bee-simple-table>

                            <!-- extra rows -->
							<bee-table-row
								v-if="calculatedRow.credit_balance || false"
								class="y-border"
								style="width:100%;"
								:item="calculatedRow"
								:headers="credit_headers_extension"
								:editable="false"
							>
								<template
									v-for="header in credit_headers_extension"
									v-slot:[`item.${credit_headers_extension.indexOf(header)}`]="{ item }"
								>
									<bee-money-field
										context="final_account"
										:action-name="actions.GET"
										class="input-text-center"
										v-if="header.type == 'money'"
										:inside-table="true"
										:readonly="true"
										:key="header.id"
										v-model="item[`${header.value}`]"
									></bee-money-field>
									<span v-else :key="header.id">{{item[`${header.value}`]}}</span>
								</template>
							</bee-table-row>
							
                            <bee-table-row
								v-if="calculatedWarehousesInventoryRow.credit_balance && calculatedWarehousesInventoryRow.credit_balance.amount"
								class="y-border"
								style="width:100%;"
								:item="calculatedWarehousesInventoryRow"
								:headers="credit_headers_extension"
								:editable="false"
							>
								<template
									v-for="header in credit_headers_extension"
									v-slot:[`item.${credit_headers_extension.indexOf(header)}`]="{ item }"
								>
									<bee-money-field
										context="final_account"
										:action-name="actions.GET"
										class="input-text-center"
										v-if="header.type == 'money'"
										:inside-table="true"
										:readonly="true"
										:key="header.id"
										v-model="item[`${header.value}`]"
									></bee-money-field>
									<span v-else :key="header.id">{{item[`${header.value}`]}}</span>
								</template>
							</bee-table-row>
                            
							<div class="d-inline" v-if="sum_result.sum_credits">
								<bee-table-row
									v-if="sum_result.sum_credits.amount"
									class="y-border"
									style="width:100%;"
									:item="sum_result"
									:headers="sum_credits_headers"
									:editable="false"
								>
									<template
										v-for="header in sum_credits_headers"
										v-slot:[`item.${sum_credits_headers.indexOf(header)}`]="{ item }"
									>
										<bee-advanced-money-label
											:currencies="currencies"
											:bold="false"
											style="font-size:16px !important"
											class="input-text-center"
											v-if="header.type == 'money'"
											:with-color="true"
											:key="header.id"
											v-model="item[`${header.value}`]"
										></bee-advanced-money-label>
									</template>
								</bee-table-row>
							</div>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-layout>
	</div>
</template>
<script>
// import { mapState } from "vuex";
import actions from "../../../../permissions/actions-names.js";
export default {
	props: ['activeTab', 'final_account', 'configs'],
	data() {
		return {
			actions,
		};
	},
	computed: {
		// ...mapState("configs", ["configs"]),
		/* ...mapState({
			final_account: state => state.statements.final_account
		}), */

		debit_headers() {
			return [
				{
					text: this.$t('headers.account-no'),
					value: " account_id",
					type: "accounts-autocomplete",
					width: "20%",
					settings: { itemText: "accounting_no" }
				},
				{
					text: this.$t('headers.account'),
					value: "account_id",
					type: "accounts-autocomplete",
					width: "30%",
					settings: { itemText: "name" }
				},
				{
					text: this.$t('headers.balance'),
					value: "debit_balance",
					type: "money",
					width: "50%",
					editable: true
				}
			]
		},
		debit_headers_extension() {
			return [
				{ text: "", value: "1", type: "string", width: "20%" },
				{ text: this.$t('headers.account'), value: "name", type: "string", width: "30%" },
				{ text: this.$t('headers.balance'), value: "debit_balance", type: "money", width: "50%" }
			]
		},
		credit_headers_extension() {
			return [
				{ text: "", value: "1", type: "string", width: "20%" },
				{ text: this.$t('headers.account'), value: "name", type: "string", width: "30%" },
				{ text: this.$t('headers.balance'), value: "credit_balance", type: "money", width: "50%" }
			]
		},
		credit_headers() {
			return [
				{
					text: this.$t('headers.account-no'),
					value: " account_id",
					type: "accounts-autocomplete",
					width: "20%",
					settings: { itemText: "accounting_no" }
				},
				{
					text: this.$t('headers.account'),
					value: "account_id",
					type: "accounts-autocomplete",
					width: "30%",
					settings: { itemText: "name" }
				},
				{
					text: this.$t('headers.balance'),
					value: "credit_balance",
					type: "money",
					width: "50%",
					editable: true
				}
			]
		},
		sum_credits_headers() {
			return [
				{ text: "", value: "1", type: "", width: "50%" },
				{ text: this.$t('headers.balance'), value: "sum_credits", type: "money", width: "50%" }
			]
		},
		sum_debits_headers() {
			return [
				{ text: "", value: "1", type: "", width: "50%" },
				{ text: this.$t('headers.balance'), value: "sum_debits", type: "money", width: "50%" }
			]
		},

		sum_result() {
			switch (this.activeTab) {
				case 0:
					return (
						this.final_account?.operation_sum_result || {
							sum_credits: null,
							sum_debits: null
						}
					);
				case 1:
					return (
						this.final_account?.trade_sum_result || {
							sum_credits: null,
							sum_debits: null
						}
					);
				case 2:
					return (
						this.final_account?.gains_and_losses_sum_result || {
							sum_credits: null,
							sum_debits: null
						}
					);
				case 3:
					return (
						this.final_account?.budget_sum_result || {
							sum_credits: null,
							sum_debits: null
						}
					);
				default:
					return null;
			}
		},
		calculatedRow() {
			return (
				this.final_account?.calculated_final_account_row || {
					debit_balance: null,
					credit_balance: null
				}
			);
        },
        calculatedWarehousesInventoryRow() {
            return (
                this.final_account?.calculated_warehouses_inventory_row || {
                    credit_balance: null
                }
            );
		},
		final_accounts_debit_rows() {
			return this.final_account
				? this.final_account.final_account_rows?.filter(c => c.credit_balance == null)
				: [];
		},
		final_accounts_credit_rows() {
			return this.final_account
				? this.final_account.final_account_rows?.filter(c => c.credit_balance != null)
				: [];
		},
		currencies() {
			return this.configs?.currencies;
		}
	},

	i18n: {
		messages:{
			ar: {
				debit: 'مدين',
				credit: 'دائن',

				'headers': {
					'account-no': 'رقم الحساب',
					'account': 'الحساب',
					'balance': 'الرصيد',
				},
			},
			en: {
				debit: 'Debit',
				credit: 'Credit',

				'headers': {
					'account-no': 'ID',
					'account': 'Account',
					'balance': 'Balance',
				},
			},
			es: {
				debit: 'Débito',
				credit: 'Crédito',

				'headers': {
					'account-no': 'Número de cuenta',
					'account': 'Cuenta',
					'balance': 'Balance',
				},
			},
		}
	}
};
</script>
<style>
.card .v-text-field.v-text-field--enclosed .v-text-field__details {
	display: none !important;
}
</style>
<style scoped>
.y-border {
	border-right: 1px solid !important;
	border-left: 1px solid !important;
	border-left-color: #f1f1f1 !important;
	border-right-color: #f1f1f1 !important;
}
</style>